import { FC } from 'react'

type IconArrowLeftProps = {
  width?: string
  height?: string
}

export const IconArrowLeft: FC<IconArrowLeftProps> = ({
  width = '16',
  height = '16',
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 16 16"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 12L6 8L10 4"
        stroke="#999999"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </svg>
  )
}
